import { captureSentryMessage } from '@shared/sentry';
import { ONE_MINUTE_MS, ONE_SECOND_MS } from '@shared/utils/constants';
import { reloadChromeRuntimeIfPossible, setLocalStorage } from '../utils';
import { getBufferedRequestCount } from '@shared/extension/utils/stored-requests';

const IDLE_CHECKING_INTERVAL_SECONDS = (10 * ONE_MINUTE_MS) / ONE_SECOND_MS;

export function startHandlingStateChange(): void {
  chrome.idle.setDetectionInterval(IDLE_CHECKING_INTERVAL_SECONDS);
  chrome.idle.onStateChanged.addListener(async newState => {
    try {
      // Get previous state before updating storage
      const previousState = await chrome.storage.local
        .get('idleState')
        .then(result => result.idleState)
        .catch(() => null);
      const totalBufferedRequests = await getBufferedRequestCount();

      // Log state change first
      captureSentryMessage(`Chrome state changed from ${previousState} to ${newState}, ${totalBufferedRequests} buffered requests`, {
        previousState,
        newState,
        checkingIntervalSeconds: IDLE_CHECKING_INTERVAL_SECONDS,
        totalBufferedRequests,
        _context: {
          source: 'state-change-handler',
          runtime: {
            lastError: chrome.runtime.lastError?.message,
          },
        },
      });

      await setLocalStorage('idleState', newState);
      await reloadChromeRuntimeIfPossible();
    } catch (e) {
      console.error('Failed to handle state change:', e);
      captureSentryMessage('Failed to handle state change', { error: e });
    }
  });

  captureSentryMessage('Idle state monitoring initialized', {
    checkingIntervalSeconds: IDLE_CHECKING_INTERVAL_SECONDS,
  });
}
